const actions = {
    ADMIN_DASHBOARD_START: 'ADMIN_DASHBOARD_START',
    ADMIN_DASHBOARD_SUCCESS: 'ADMIN_DASHBOARD_SUCCESS',
    ADMIN_DASHBOARD_FAILURE: 'ADMIN_DASHBOARD_FAILURE',
};

export default actions;